<template>
  <IconFont class="icon-data" name="icon-a-shujuzhongxinsbeifen2x" />
</template>

<script>
  export default {
    name: 'icon-data',
  };
</script>

<style>
  .icon-data {
    font-size: 16px;
  }
</style>
